export default "__VITE_ASSET__WZZyVUv4__"